module.exports = __webpack_public_path__ + "img/Legends-of-Tampa-Bay-Suite.6d54f850.jpg";